// extracted by mini-css-extract-plugin
module.exports = {"power-ocean-home-F":"F_power-ocean-home-F__rii0E"};